import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Table2, ArrowUpRight, FileDown, Loader2 } from "lucide-react";
import { toast } from "sonner";
import api from "../../lib/api";
import { useFideicomiso } from "../../lib/fideicomiso";
import { Button } from "../../components/ui/button";

export default function TapeCortes() {
    const { selected } = useFideicomiso();
    const [rows, setRows] = useState([]);
    const [loading, setLoading] = useState(false);

    const load = async () => {
        setLoading(true);
        try {
            const { data } = await api.get("/tape/cortes");
            const filtered = selected ? (data || []).filter((c) => c.fideicomiso_id === selected.id) : (data || []);
            setRows(filtered);
        } finally {
            setLoading(false);
        }
    };
    useEffect(() => { load(); /* eslint-disable-next-line */ }, [selected?.id]);

    const dlRejects = async (corte_id) => {
        try {
            const r = await api.get(`/tape/cortes/${corte_id}/rejects`, { responseType: "blob" });
            const url = URL.createObjectURL(r.data);
            const a = document.createElement("a");
            a.href = url;
            a.download = `rejects_${corte_id}.csv`;
            a.click();
            URL.revokeObjectURL(url);
        } catch (err) {
            toast.error("Sin archivo de rechazos");
        }
    };

    return (
        <div className="p-8 lg:p-10 max-w-[1600px] space-y-6" data-testid="tape-cortes-page">
            <div>
                <div className="text-[11px] uppercase tracking-[0.3em] text-[color:var(--brand-dark-gold)] font-semibold mb-2">
                    V1 · Garantía {selected ? `· ${selected.numero_interno}` : ""}
                </div>
                <h1 className="font-display text-4xl tracking-tight flex items-center gap-3">
                    <Table2 className="h-8 w-8 text-[color:var(--brand-dark-gold)]" />
                    Cortes de tape
                </h1>
                <p className="text-sm text-muted-foreground mt-1">
                    Snapshots de cartera ingeridos. Cada corte queda con hash SHA-256 del archivo
                    original y sirve como input para elegibilidad, BB y covenants.
                </p>
            </div>

            <div className="flex gap-2">
                <Link to="/v1/tape">
                    <Button variant="outline" data-testid="ir-tape-upload">Subir nuevo corte</Button>
                </Link>
            </div>

            <div className="rounded-md border border-border overflow-hidden bg-card">
                <table className="trf-table" data-testid="cortes-table">
                    <thead>
                        <tr>
                            <th>Corte</th>
                            <th>Fecha corte</th>
                            <th>Facility</th>
                            <th className="text-right">Filas totales</th>
                            <th className="text-right">Válidas</th>
                            <th className="text-right">Rechazadas</th>
                            <th>Hash archivo</th>
                            <th>Subido</th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        {rows.map((c) => (
                            <tr key={c.corte_id} data-testid={`corte-row-${c.corte_id}`}>
                                <td className="hash-cell">{c.corte_id?.slice(0, 12)}…</td>
                                <td className="tabular">{c.fecha_corte}</td>
                                <td className="text-xs">
                                    {c.facility_id && c.facility_id !== "F0-DUMMY" ? (
                                        <Link to={`/v1/facilities/${c.facility_id}`}
                                            className="underline decoration-dotted underline-offset-2">
                                            {c.facility_id?.slice(0, 12)}…
                                        </Link>
                                    ) : (
                                        <span className="badge-mock">sin facility</span>
                                    )}
                                </td>
                                <td className="text-right tabular">{c.registros_totales}</td>
                                <td className="text-right tabular text-[color:var(--brand-exito)]">{c.registros_validos}</td>
                                <td className="text-right tabular text-[color:var(--brand-coral)]">{c.registros_rechazados}</td>
                                <td className="hash-cell">{c.file_hash?.slice(0, 14)}…</td>
                                <td className="text-xs">
                                    {c.uploaded_at?.slice(0, 16)}<br/>
                                    <span className="text-[10px] text-muted-foreground">{c.uploaded_by}</span>
                                </td>
                                <td>
                                    {c.registros_rechazados > 0 && (
                                        <Button size="sm" variant="ghost"
                                            onClick={() => dlRejects(c.corte_id)}
                                            data-testid={`dl-rejects-${c.corte_id}`}>
                                            <FileDown className="h-3 w-3" />
                                        </Button>
                                    )}
                                </td>
                            </tr>
                        ))}
                        {rows.length === 0 && !loading && (
                            <tr>
                                <td colSpan={9} className="text-center py-10 text-muted-foreground">
                                    Sin cortes. Sube uno en <Link to="/v1/tape" className="underline">Tape (ingesta)</Link>.
                                </td>
                            </tr>
                        )}
                        {loading && (
                            <tr><td colSpan={9} className="text-center py-6">
                                <Loader2 className="h-4 w-4 animate-spin inline" />
                            </td></tr>
                        )}
                    </tbody>
                </table>
            </div>
        </div>
    );
}
